import Vue from 'vue';
import './assets/css/index.scss';
import './middleware';
import singleSpaVue from 'single-spa-vue';
import store from './store';
import router from './router';
import App from './App.vue';
import * as filters from './utils/filters';
import i18n from './utils/i18n';

Vue.config.productionTip = false;

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h) {
      return h(App, {
        props: {},
      });
    },
    store,
    router,
    i18n,
  },
});

export const { bootstrap } = vueLifecycles;
export const { mount } = vueLifecycles;
export const { unmount } = vueLifecycles;
